import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { ClearButton, PrimaryButton } from 'ui/Components';

/**
 * Discard changes if changes aren't needed
 */
export default class DiscardButton extends Component {
  static propTypes = {
    disabled: propTypes.bool,
    id: propTypes.string.isRequired,
    isNewStatus: propTypes.bool.isRequired,
    name: propTypes.string.isRequired,
    notifySuccess: propTypes.func.isRequired,
    parentFolderId: propTypes.string,
    removeActivePage: propTypes.func.isRequired,
    type: propTypes.string.isRequired,
    version: propTypes.oneOfType([propTypes.string, propTypes.number]),
    visit: propTypes.func.isRequired,
    visitFolder: propTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    parentFolderId: '',
    version: '1'
  };

  constructor() {
    super();

    this.state = {
      showDiscardConfirmationModal: false
    };

    this.handleDiscardClick = this.handleDiscardClick.bind(this);
    this.handleModalToggleClick = this.handleModalToggleClick.bind(this);
    this.discard = this.discard.bind(this);
  }

  /**
   * reload to remove any changes
   */
  handleDiscardClick() {
    this.setState({ showDiscardConfirmationModal: true });
  }

  /**
   * toggle discard modal
   */
  handleModalToggleClick() {
    this.setState(ps => ({ showDiscardConfirmationModal: !ps.showDiscardConfirmationModal }));
  }

  /**
   * handle discard of changes
   */
  discard() {
    const {
      id,
      isNewStatus,
      name,
      notifySuccess,
      parentFolderId,
      removeActivePage,
      type,
      visit,
      visitFolder,
      version
    } = this.props;

    if (isNewStatus) {
      visitFolder(parentFolderId);
      removeActivePage();
    } else {
      visit(id, version);
    }

    this.handleModalToggleClick();

    setTimeout(() => {
      notifySuccess(`Changes to ${type} ${name} have been discarded.`);
    }, 800);
  }

  render() {
    const { disabled, name, type } = this.props;

    const { showDiscardConfirmationModal } = this.state;

    return (
      <Fragment>
        <ClearButton
          onClick={this.handleDiscardClick}
          data-test-id="discardButton-discard"
          disabled={disabled}
        >
          Discard
        </ClearButton>
        <Modal isOpen={showDiscardConfirmationModal} toggle={this.handleModalToggleClick}>
          <ModalHeader toggle={this.handleModalToggleClick}>Discard Changes</ModalHeader>
          <ModalBody>
            <div className="pb-4">{`Discard changes made to ${type} ${name}?`}</div>
            <div className="d-flex justify-content-end mt-auto pb-3">
              <ClearButton
                onClick={this.handleModalToggleClick}
                color="link"
                data-test-id="discardButton-cancel"
              >
                Nevermind
              </ClearButton>
              <PrimaryButton onClick={this.discard} data-test-id="discardButton-confirm">
                Yes, Discard Changes
              </PrimaryButton>
            </div>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}
